export default ({ app }) => {
  // HMR 중복 등록 방지: 이전 리스너 제거 후 재등록
  if (window.__clickTrackerHandler) {
    document.removeEventListener('click', window.__clickTrackerHandler, true)
  }

  let clickedParentId = null
  let clickedProductId = null
  let clickedTitleText = null
  let clickedSubText = null
  let clickedBannerAlt = null
  let clickedNavigationFrom = null

  const clickHandler = (e) => {
    clickedNavigationFrom = e.target
      .closest('[data-ga-navigation-from]')
      ?.getAttribute('data-ga-navigation-from') || null
    clickedParentId = e.target.closest('[id^="account-"]')?.id || null
    if (!clickedParentId && e.target.closest('.popover-product')) {
      clickedParentId = 'popover-product'
    }

    // popover-product 엑스버튼 클릭 감지
    const closeButton = e.target.closest('.close-button')
    if (closeButton && e.target.closest('.popover-product')) {
      clickedParentId = 'popover-product'
      clickedSubText = 'close'

      // 즉시 이벤트 전송
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'button_click',
          click_parent_id: clickedParentId,
          click_product_id: clickedProductId,
          click_title_text: clickedTitleText,
          click_sub_text: clickedSubText,
          current_page: clickedNavigationFrom || app.router.currentRoute.fullPath,
        })
      }

      // 초기화
      clickedParentId = null
      clickedProductId = null
      clickedTitleText = null
      clickedSubText = null
      clickedBannerAlt = null
      clickedNavigationFrom = null
      return
    }

    clickedProductId = e.target.closest('[id^="pdNo-"]')?.id || null

    if (!clickedProductId) {
      const productContent = e.target.closest('[data-prod^="pdNo-"]')
      clickedProductId = productContent?.getAttribute('data-prod') || null
    }

    const buttonItem = e.target.closest('.button-item')
    clickedSubText = buttonItem?.querySelector('.btn')?.textContent.trim() || null

    if (!clickedSubText && buttonItem) {
      clickedSubText = buttonItem.textContent.trim() || null
    }

    const heartButton = e.target.closest('.btn-heart-prod')
    if (heartButton && !clickedSubText) {
      clickedSubText = heartButton.getAttribute('aria-label') || null
    }

    const bannerLink = e.target.closest('.banner-area a, .swiper-wrap a')
    if (bannerLink) {
      const bannerImg = bannerLink.querySelector('img')
      clickedBannerAlt = bannerImg?.getAttribute('alt') || null
    }

    const productCard = e.target.closest('.product-card')

    if (productCard) {
      const section = productCard.closest('[id^="account-"]') || productCard.closest('.section__inner') || productCard.closest('section') || document
      const titleArea = section.querySelector('.title-area')
      clickedTitleText = titleArea?.querySelector('.title')?.textContent.trim() || null

      if (!clickedTitleText) {
        const exhTop = section.querySelector('.exh-product-section__top')
        clickedTitleText = exhTop?.querySelector('.title')?.textContent.trim() || null
      }
    } else {
      clickedTitleText = null
    }

    if (!clickedTitleText && clickedParentId) {
      const accountEl = e.target.closest('[id^="account-"]')
      clickedTitleText = accountEl?.querySelector('[class*="title"]')?.textContent.replace(/\s+/g, ' ').trim() || null
    }

    if (clickedSubText) {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'button_click',
          click_parent_id: clickedParentId,
          click_product_id: clickedProductId,
          click_title_text: clickedTitleText,
          click_sub_text: clickedSubText,
          current_page: clickedNavigationFrom || app.router.currentRoute.fullPath,
        })
      }

      // 초기화
      clickedParentId = null
      clickedProductId = null
      clickedTitleText = null
      clickedSubText = null
      clickedBannerAlt = null
      clickedNavigationFrom = null
    }
  }

  window.__clickTrackerHandler = clickHandler
  document.addEventListener('click', clickHandler, true)

  // 라우터 네비게이션 추적
  app.router.beforeEach((to, from, next) => {
    const isRouteChanged = from.path !== to.path || from.fullPath !== to.fullPath
    if ((clickedParentId || clickedProductId || clickedTitleText || clickedBannerAlt) && isRouteChanged) {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'button_click',
          click_parent_id: clickedParentId,
          click_product_id: clickedProductId,
          click_title_text: clickedTitleText,
          click_sub_text: clickedSubText,
          click_banner_alt: clickedBannerAlt,
          navigation_from: clickedNavigationFrom || from.fullPath,
          navigation_to: to.fullPath,
        })
      }

      clickedParentId = null
      clickedProductId = null
      clickedTitleText = null
      clickedSubText = null
      clickedBannerAlt = null
      clickedNavigationFrom = null
    }
    next()
  })
}
